import * as React from 'react';
import type ColumnSynchronizer from './ColumnSynchronizer';
import DataTableHeaderCell from './DataTableHeaderCell';
import type {ColumnPropType} from './propTypes';
import {columnPropType, columnSynchronizerPropType} from './propTypes';

export type Props = {
    column: ColumnPropType,
    columnSynchronizer?: ColumnSynchronizer,
};

export default class DataTableHeaderLabelCell extends React.PureComponent<Props> {

    static propTypes = {
        column: columnPropType.isRequired,
        columnSynchronizer: columnSynchronizerPropType,
    };

    props: Props;

    render(): React.ReactNode {
        const {column, ...otherProps} = this.props;
        const {label} = column;

        return (
            <DataTableHeaderCell column={column} {...otherProps}>
                {typeof label === 'function' ? React.createElement(label) : label}
            </DataTableHeaderCell>
        );
    }

}
